module.exports = __webpack_public_path__ + "img/profile.d95b1e11.svg";